import banner from './banner'
import panel from './panel'
import goodsGrid from './goodsGrid'
import imgHotzone from './imgHotZone'
import floor from './floor'
export default {
  [banner.name]: { widget: banner },
  [panel.name]: {widget: panel},
  [goodsGrid.name]: { widget: goodsGrid },
  [imgHotzone.name]: { widget: imgHotzone },
  [floor.name]: { widget: floor },
}



// WEBPACK FOOTER //
// ./src/components/plugins/index.js